import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useCreateTargetListMutation } from "../../../../../features/targetlistApi";
import { addBannerWithTimeout } from "../../../../lib/centralizedBanner/slice";
import { useAppDispatch } from "../../../../lib/redux/hooks";
import Button from "../../../../ui/molecules/button";
import { Spinner } from "../../../../ui/molecules/spinner";
import { TabMenu } from "../../../../ui/organisms/tabs/tabMenu";
import { TabPages } from "../../../../ui/organisms/tabs/tabPages";
import { NewTargetListFormValues, newTargetListSchema } from "../../../targetList/editTargetListDetails/validation";
import { ProjectDTO } from "../../dto";
import { Form } from "./form";

interface Props {
  project: ProjectDTO
}
export function AddTargetList({ project }: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [createTargetList, { isLoading }] = useCreateTargetListMutation();

  const form = useForm<NewTargetListFormValues>({
    resolver: zodResolver(newTargetListSchema),
    defaultValues: {
      projectId: project.id!,
      name: "",
      commercialIds: [],
      departments: [],
      roles: [],
      revenue: "undefined:undefined:undefined",
      employeesNumber: "undefined:undefined:undefined",
      sectors: [],
      categories: [],
    }
  })

  const handleSubmit = async () => {
    try {
      const response = await createTargetList({ data: form.getValues() }).unwrap();
      navigate('/edit-target-list/' + response.targetListId + '/specifics/' + project.id);
      dispatch(addBannerWithTimeout({
        variant: "success",
        message: "Lista target creata con successo"
      }))
    } catch (error) {
      dispatch(addBannerWithTimeout({
        variant: "error",
        message: "Errore durante la creazione della lista target"
      }))
    }
  }

  const [direction, setDirection] = useState<"left" | "right">("left");
  const [tabValue, setTabValue] = useState<number>(0);

  return (
    <div className="p-4 h-full max-h-full">
      <div className="flex flex-col h-full max-h-full bg-white rounded-2xl shadow-sm">
        <div className="px-4 flex justify-between items-center">
          <div className="flex items-center gap-6">
            <span className="text-heading-xs font-semibold text-neutral-800">
              Nuova lista target
            </span>
            <TabMenu
              direction={direction}
              setDirection={(value) => setDirection(value)}
              setValue={(e) => {
                setTabValue(e);
              }}
              value={tabValue}
              items={[
                {
                  icon: <></>,
                  label: "Specifiche lista",
                },
                {
                  icon: <></>,
                  label: "Persone (0)",
                  disabled: true,
                },
                {
                  icon: <></>,
                  label: "Aziende (0)",
                  disabled: true,
                },
              ]}
            />
          </div>
          {isLoading ? (
            <Spinner />
          ) : (
            <Button
              size={"sm"}
              iconPosition={"left"}
              variant={"solid"}
              color={"blue"}
              label="Salva lista"
              onClick={() => form.handleSubmit(handleSubmit)()}
            />
          )}
        </div>
        <div style={{ height: 'calc(100% - 64px)' }}>
          <TabPages
            direction={direction}
            setDirection={(value) => setDirection(value)}
            pages={[
              <Form form={form} key={0} commercials={project?.commercials?.map(c => c.id) ?? []} />,
              <div key={1} className="h-full"></div>,
              <div key={2} className="h-full"></div>,
            ]}
            value={tabValue}
            setValue={(e) => {
              setTabValue(e);
            }}
          />
        </div>
      </div>
    </div>
  );
}
